export type ServiceInterest =
  | "residential-investment"
  | "vehicle-asset"
  | "business-loans";

export type ReferralSource =
  | "google"
  | "facebook"
  | "instagram"
  | "friend-family"
  | "real-estate-agent"
  | "existing-client"
  | "signage"
  | "other";

export type ContactFormData = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  services: ServiceInterest[];
  loanAmount?: string;
  message: string;
  referralSource?: ReferralSource;
  recaptchaToken?: string;
};

export const serviceLabels: Record<ServiceInterest, string> = {
  "residential-investment": "Residential / Investment Lending",
  "vehicle-asset": "Vehicle & Asset Finance",
  "business-loans": "Business Loans",
};

export const referralLabels: Record<ReferralSource, string> = {
  google: "Google Search",
  facebook: "Facebook",
  instagram: "Instagram",
  "friend-family": "Friend or Family",
  "real-estate-agent": "Real Estate Agent",
  "existing-client": "Existing Client",
  signage: "Signage / Banner",
  other: "Other",
};

// Keep for backwards compatibility with API
export type LoanType =
  | "home-loan"
  | "refinance"
  | "investment"
  | "first-home"
  | "construction"
  | "business"
  | "other";

export const loanTypeLabels: Record<LoanType, string> = {
  "home-loan": "Home Loan",
  refinance: "Refinancing",
  investment: "Investment Property",
  "first-home": "First Home Buyer",
  construction: "Construction Loan",
  business: "Business Loan",
  other: "Other / General Inquiry",
};
